module.exports = __webpack_public_path__ + "images/emoji/scream_cat.eb5611c98dcd3088c55a.png";